import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import styles from "./EstimatePDF.module.scss";
import classNames from "classnames/bind";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { title } from "process";
import { generateSectionPdf } from "./EstimatePDFExport";


const cx = classNames.bind(styles);

interface EstimatePDFProps {
  data: any,
}

export interface ChildHandle {
  exportPdf: () => void; 
}

const PAGE_WIDTH = 595;
const PAGE_HEIGHT = 842;

const DESIGN_WIDTH_PX = 928;
const SCALE = PAGE_WIDTH / DESIGN_WIDTH_PX;

const MARGIN_TOP = 40;
const MARGIN_BOTTOM = 40;


const EstimatePDF = forwardRef<ChildHandle, EstimatePDFProps>((props, ref) => {
    const {data} = props;
    const pages:string[] = ['title-page' , 'front-page', 'quote-page', 'auth-header', 'terms-page', 'cbr-page'];
    const [previewUrl, setPreviewUrl] = useState<string | null>(null);
    const pdfRef = useRef<HTMLDivElement>(null);

    useImperativeHandle(ref, () => ({
        async exportPdf() {
            const pdf = new jsPDF("p", "mm", "a4");

            for (let i = 0; i < pages.length; i++) {
                const element:any = document.getElementById(pages[i]);
                if(!element) continue;
                const canvas = await html2canvas(element, { scale: 2 });
                const img = canvas.toDataURL("image/png");

                const pageWidth = 210;
                const pageHeight = (canvas.height * pageWidth) / canvas.width;

                if (i > 0) pdf.addPage();
                pdf.addImage(img, "PNG", 0, 0, pageWidth, pageHeight);
            }

            // pdf.save("multi-page.pdf");

            const pdfBlob = pdf.output("blob");
            const url = URL.createObjectURL(pdfBlob);

            setPreviewUrl(url);
        },

    }));

     const exportPdf = async () => {
        const pdf = new jsPDF("p", "mm", "a4");

        for (let i = 0; i < pages.length; i++) {
            const element:any = document.getElementById(pages[i]);
            if(!element) continue;
            const canvas = await html2canvas(element, { scale: 2 });
            const img = canvas.toDataURL("image/png");

            const pageWidth = 210;
            const pageHeight = (canvas.height * pageWidth) / canvas.width;

            if (i > 0) pdf.addPage();
            pdf.addImage(img, "PNG", 0, 0, pageWidth, pageHeight);
        }

        // pdf.save("multi-page.pdf");

        const pdfBlob = pdf.output("blob");
        const url = URL.createObjectURL(pdfBlob);

        setPreviewUrl(url);
    }

    const exportPdfPro = async (data:any) => {

        let pdfBlob = await generateSectionPdf(data);
        const pdfUrl = URL.createObjectURL(pdfBlob);
        setPreviewUrl(pdfUrl);
    }

    const convertDateToString = (date:Date) => {
        return date.toLocaleDateString("en-US", {
            month: "short",
            day: "2-digit",
            year: "numeric"
        }).toUpperCase();
    }

    const getQuoteArrayString = (quotes:any[]) =>{
        let rowString:{label:string, type:string}[] = []
        rowString.push( {label : 'Description', type:"title" });

        quotes && quotes.map(quote=>{
            if(!quote.isVisible) return

            rowString.push( {label : quote.title, type:"title-section" });

            quote.sectionItems.map((section:any) => {
                rowString.push( {label : section.itemName, type:"section" });
            })
        })

        return rowString;
    }

    useEffect(()=>{
        setTimeout(()=>{
            exportPdfPro(data);
        },100)
    },[data])

    return <>       
        {previewUrl && (
            <iframe
                src={previewUrl+"#navpanes=0&view=FitH"}
                style={{ width: "600px", height: "calc(100% - 20px)", border: "1px solid #ccc" }}
            />
            )}

        <div style={{
            position:"relative",
            overflow:"hidden",
            height: "0"

        }}>
            <div style={{ width: "928px", opacity:0, background:"#ffffff", position:'absolute' }}>
                <div id="title-page" className={cx('page-a4')} style={{ width: "928px", height: "1123px" }}>
                    <div className={cx("title-image")}>
                        <img src={data.titleFileUrl ?? ""}/>

                        <h1 className={cx('estimate-name')}>{data.name}</h1>
                        <h1 className={cx('estimate-company')}>{data.companyName}</h1>
                        <p className={cx('estimate-company-help')}>Comprehensive roofing services for your property</p>
                    </div>

                    <div className={cx('estimate-info')}>
                        <div className={cx('info-box')}>
                            <h3>Prepared For:</h3>

                            <p>{data.firstName} {data.firstName}</p>
                            <p>{data.address}</p>
                            <p>{data.stateProvince}, {data.city}</p>
                        </div>

                        <div className={cx('info-box')}>
                            <h3>Estimate Date:</h3>

                            <p>{convertDateToString(data.estimateDate ? new Date(data.estimateDate) : new Date()) }</p>
                            <p>Valid for 30 days</p>
                            <p>{data.province}, {data.zipCodePostalCode}</p>
                        </div>
                    </div>

                    <div  className={cx('estimate-who')}>
                        <h2>WHO WE ARE</h2>
                        <div style={{marginTop: '40px'}}
                            dangerouslySetInnerHTML={{ __html: data.usDescription }}
                        />

                        <div className={cx('achievements')}>
                            <div className={cx('achievement')}>
                                <h3>15+</h3>
                                <h4>Years Experience</h4>
                            </div>

                            <div className={cx('achievement')}>
                                <h3>100%</h3>
                                <h4>Licensed & Insured</h4>
                            </div>

                            <div className={cx('achievement')}>
                                <h3>500+</h3>
                                <h4>Satisfied Customers</h4>
                            </div>
                        </div>
                    </div>

                    <div className={cx('our-services')}>
                        <h3>Our Services</h3>

                        <ul>
                            <li>Complete roof replacement and installation</li>
                        </ul>
                    </div>
                </div>

                <div id="quote-page" className={cx('page-a4')} style={{ width: "928px", height: "1123px" }}>
                    <h1 className={cx('quote-header')}>OWENS CORNING ROOF SYSTEM</h1>
                    <div className={cx('quote-list')}>
                        {
                            getQuoteArrayString(data.quotes).map((item, index)=>(
                                <div className={cx({
                                    quote: true,
                                    "gray": index % 2 == 0,
                                    'title': item.type == 'title',
                                    'title-section': item.type == 'title-section'
                                })}>{item.label}</div>
                            ))
                        }
                    </div>
                    
                </div>

                <div id="auth-page" className={cx('page-a4')} style={{ width: "928px", height: "1123px" }}>
                    <h1 className={cx('auth-header')}>AUTHORIZATION PAGE</h1>
                    <div className={cx('quote-list')}>
                        <div>
                            <div className={cx('auth-section-header')}>
                                <div className="" style={{width: "100px"}}></div>
                                <div style={{width: "70%"}}>Description</div>
                                <div style={{width: "30%"}}>Line total</div>
                            </div>
                            
                        
                        {
                            
                            data.optional && data.optional.sections.map((item:any, index:number)=>(
                                <div className={cx({
                                    'auth-section-row':true,
                                    gray: index % 2 == 1
                                })}>
                                    <div className="" style={{width: "100px"}}></div>
                                    <div style={{width: "70%"}}>{item.itemName}</div>
                                    <div style={{width: "30%"}}>${(item.unitPrice * item.quantity).toFixed(2)}</div>
                                </div>

                                // <div className={cx({
                                //     quote: true,
                                //     "gray": index % 2 == 0,
                                //     'title': item.type == 'title',
                                //     'title-section': item.type == 'title-section'
                                // })}>{item.label}</div>
                            ))
                        }
                        </div>
                    </div>
                    
                </div>

                <div id="terms-page" className={cx('page-a4')} style={{ width: "928px", height: "1123px" }}>
                    <h1 className={cx('auth-header')}>TERMS AND CONDITIONS</h1>

                    <div style={{marginTop: '40px'}}
                        dangerouslySetInnerHTML={{ __html: data.termsNConditions }}
                    />
                </div>

                <div id="cbr-page" className={cx('page-a4')} style={{ width: "928px", height: "1123px" }}>
                    <h1 className={cx('auth-header')}>CBR INSURANCE</h1>
                    <div style={{marginTop: '40px'}}
                        dangerouslySetInnerHTML={{ __html: data.insuranceDetails }}
                    />
                </div>
            </div>
        </div>   


    
    </>
})

export default EstimatePDF;